import { useContext } from 'react';

import { AccordionContainer } from '@/components/AccordionContainer';
import { EmptySectionContactAdmin } from '@/components/EmptySectionContactAdmin';
import { PreorderStatusCategoryRow } from '@/components/PreorderStatusCategoryRow';
import { SettingsContext } from '@/contexts/SettingsContext';
import useTranslation from '@/hooks/useTranslation';

export const SectionPreorderOverview = () => {
  const t = useTranslation();
  const { preorderStatusOrderForUser } = useContext(SettingsContext);
  return (
    <AccordionContainer keyName={'PREORDER_OVERVIEW'} visibleTitle={t('section.PREORDER_OVERVIEW')}>
      {preorderStatusOrderForUser.map((preorderStatus) => (
        <PreorderStatusCategoryRow key={`preorder-status-category-row-${preorderStatus}`} status={preorderStatus} />
      ))}
      <EmptySectionContactAdmin items={preorderStatusOrderForUser} sectionName={t('section.PREORDER_OVERVIEW')} />
    </AccordionContainer>
  );
};
